import React from 'react'
import { Link } from 'react-router'
import Date from '../../Date'
import { ROUTE_MEDIA_VIDEOS, URL_YOUTUBE } from '../../../constants'

function VideoItem({ preview, video }) {

  const clazz = preview ? "" : "col s12 m6 l3"
  const { url, title, date } = video

  return (
    <div className={clazz}>
      <div className="card">
        <div className="card-image">
          <Link activeClassName={'active'} to={`${ ROUTE_MEDIA_VIDEOS }/${ url }`}>
            <img className="responsive-img" src={ URL_YOUTUBE(url) } alt={ title }/>
          </Link>
        </div>
        <div className="card-content">
          <p>
            <span className="video-title card-title truncate">{ title }</span>
            <Date date={ date } withoutDay/><br/>
          </p>
        </div>
        <div className="card-action">
          <Link activeClassName={'active'} to={`${ ROUTE_MEDIA_VIDEOS }/${ url }`}>Voir la vidéo</Link></div>
      </div>
    </div>
  )
}

export default VideoItem



/** WEBPACK FOOTER **
 ** ./src/components/Media/Videos/VideoItem.jsx
 **/